import React from 'react';
import SiteFooter from './SiteFooter';
import './Login.css';

/**
 * Full-height auth layout: centered main content + site footer (login, register, etc.).
 */
const AuthPageShell = ({ children }) => {
  return (
    <div className="login-page-with-footer">
      <div className="login-page-with-footer__main">{children}</div>
      <SiteFooter />
    </div>
  );
};

export default AuthPageShell;
